import { to } from "@lib/utils";
import { Network } from "@models/network";
import { Wallet } from "@models/wallet";
import WalletConnect from "@walletconnect/client";
import { ReactNode, useEffect, useRef, useState } from "react";
import {
  connectWalletWCByConnector,
  initWcConnector,
  isMobile,
  WalletError,
} from "./services";

const ConnectMetamask = ({
  disabled: disabled = false,
  onClick: onClick = () => {},
  onSuccess: onSuccess = () => {},
  onError: onError = (err?: any) => {},
  children,
}: {
  disabled?: boolean;
  onClick?: () => void;
  onSuccess?: (wallet: Wallet) => void;
  onError?: (err?: any) => void;
  children?: ReactNode;
}) => {
  const metamaskWCAnchorRef = useRef<HTMLAnchorElement>(null);
  const [metamaskWCUrl, setMetamaskWCUrl] = useState("");
  const [mobile, setMobile] = useState(false);
  const [wcConnector, setWcConnector] = useState<WalletConnect | null>(null);

  useEffect(() => {
    const _mobile = isMobile();
    setMobile(_mobile);

    const init = async () => {
      const connector = await initWcConnector(false);
      if (!connector) return;
      setWcConnector(connector);
      const url = `https://metamask.app.link/wc?uri=${encodeURIComponent(
        connector.uri
      )}`;
      setMetamaskWCUrl(url);
      // console.log("ConnectMetamask", url);
    };
    init();
  }, []);

  const connectMobile = async () => {
    try {
      if (!wcConnector) throw WalletError.UNKNOWN_ERROR;

      metamaskWCAnchorRef.current
        ? metamaskWCAnchorRef.current.click()
        : window.open(metamaskWCUrl, "_blank");

      const { err, res: res } = await to(
        connectWalletWCByConnector(wcConnector)
      );
      if (!res?.walletAddress) {
        console.error(err);
        throw WalletError.REQUEST_DENIED;
      }

      const wallet = new Wallet({
        network: Network.EVM,
        address: res.walletAddress,
      });
      console.log("ConnectMetamask", wallet);
      return onSuccess(wallet);
    } catch (err) {
      console.log("signIn connectMobile", err);
      return onError(err);
    }
  };

  return (
    <>
      <div className="hidden">
        <a
          ref={metamaskWCAnchorRef}
          href={metamaskWCUrl}
          target="_self"
          rel="noopener noreferrer"
        ></a>
      </div>

      <button
        className="flex flex-row justify-center items-center w-full h-full"
        onClick={mobile ? connectMobile : onClick}
        disabled={disabled}
      >
        {children}
      </button>
    </>
  );
};

export default ConnectMetamask;
